import React from 'react';
import styled, { css } from 'styled-components';
import { IStyled } from '../../styles/types';
import { theme } from '../../styles/theme';

interface IProps extends IStyled {
  layout: 'vertical' | 'horizontal';
  size: 'short' | 'full';
}

const verticalStyles = css<{ $size: IProps['size'] }>`
  height: ${({ $size }) => ($size === 'full' ? '100%' : '16px')};
  border-right-width: 1px;
  border-right-style: solid;
`;
const horizontalStyles = css<{ $size: IProps['size'] }>`
  width: ${({ $size }) => ($size === 'full' ? '100%' : '16px')};
  border-top-width: 1px;
  border-top-style: solid;
`;
const Container = styled.div<{
  $layout: IProps['layout'];
  $size: IProps['size'];
}>`
  flex: 0 0 auto;
  border-color: ${theme.colors.border};
  ${({ $layout }) =>
    $layout === 'vertical' ? verticalStyles : horizontalStyles}
`;

const ThinDivider = ({ layout, size, className }: IProps) => (
  <Container className={className} $layout={layout} $size={size} />
);

export default ThinDivider;
